import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import { ReactComponent as AccordionArrowIcon } from '@assets/svg/ic-chevron.svg';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const HardwareOverviewDetailsSkeleton = () => {
  return [...Array(6)].map(() => (
    <div key={uuidv4()} className={style.accordionSkeletonBlock}>
      <AccordionArrowIcon className={style.arrow} />
      <SkeletonBlock className={style.skeletonText} />
    </div>
  ));
};

export default HardwareOverviewDetailsSkeleton;
